<template>
	<div>
		<h1>{{ title }}</h1>
		<div class="tag-sections">
			<section class="tag">
				<p>Gib alle Aufgaben und Tätigkeitsbereiche an, die dich interessieren: das erhöht deine Chancen auf den
					passenden Job!</p>
				<CharacteristicSelectInline
					v-model="functions"
					:characteristic-items="functionCharacteristicItems"
					:characteristic-type="meta.functionType"
					:initial-show-all="hasFunctions"
					:initial-amount="10"
					:nothing-allowed="nothingAllowed"
					:fan-config="{
						nothingAllowed: {
							minimumLevel: 1
						},
						withKeyword: true,
						showMultipleHint: true,
						titleFormats: {
							default: 'Welche Bereiche in %characteristicLabel%?',
							level: {
								1: 'Welche Bereiche in %title%?'
							}
						},
						searchConfig: {
							catalog: meta.searchCatalogFunction
						}
					}"
					:supplements-config="{
						nothingAllowed: true,
						types: functionSupplementTypes
					}"
					:selected-childs-config="{
						noChildrenAppendix: 'Alle Tätigkeiten möglich'
					}"
					show-multiple-hint
					with-keyword
					keyword-placeholder="Suchen ..."
					:search-catalog="meta.searchCatalogFunction"
					label-type="application"
					:group-by-letter="{
						enabled: true
					}"
					@input="emitChangeEvent"
				/>
			</section>
		</div>
	</div>
</template>

<script>
import {mapState} from "vuex";
import CharacteristicSelectInline from "@/vue/characteristic/SelectInline"
import {isDefined} from "@/helper/Value";
import {getQueryParams} from "@/helper/Url";
import {arrayIsNotEmpty} from "@/helper/Array";
import * as Functions from "@/helper/characteristic/Functions";
import _ from "lodash";
import {RELEVANT_SUPPLEMENT_TYPES} from "@/helper/characteristic/Functions";

export default {

	components: {
		CharacteristicSelectInline,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		title: {
			type: String,
			required: true,
		},
		employmentModes: {
			type: Array,
			required: true,
		},
	},

	data ()
	{
		const queryParams = getQueryParams();

		return {
			channel: queryParams.channel,
			functions: this.value?.functions,
		};
	},

	computed: {
		...mapState('meta', [
			'meta',
		]),
		isNothingOverallEligible ()
		{
			return Functions.isNothingAllowedEligible(
				_.map(this.employmentModes, 'item')
			);
		},
		functionSupplementTypes ()
		{
			return RELEVANT_SUPPLEMENT_TYPES;
		},
		nothingAllowed ()
		{
			if (!this.isNothingOverallEligible)
			{
				return undefined;
			}

			return {
				text: 'Es sind alle Tätigkeiten möglich'
			}
		},
		hasFunctions ()
		{
			return isDefined(this.functions) && arrayIsNotEmpty(this.functions);
		},
		functionCharacteristicItems ()
		{
			const items = this.meta.function;

			if (this.channel)
			{
				items.sort((a, b) =>
				{
					const isChannelA = a.naturalId === this.channel;
					const isChannelB = b.naturalId === this.channel;

					if (isChannelA === isChannelB)
					{
						return a.label.localeCompare(b.label);
					}

					return isChannelA && !isChannelB ? -1 : 1;
				});
			}

			return items;
		},
		functionsValid ()
		{
			if (!isDefined(this.functions))
			{
				return false;
			}

			return this.isNothingOverallEligible || arrayIsNotEmpty(this.functions);
		},
		valid ()
		{
			return this.functionsValid;
		},
	},

	methods: {
		emitChangeEvent ()
		{
			this.$emit('input', {
				functions: this.functions,
				valid: this.valid
			});
		},
	},
}
</script>
